import { useRef } from "react";

import { CONSTANTS } from "constants/general";
import {
  BootstrapDialog,
  BootstrapDialogActions,
  BootstrapDialogContent,
  StyledDialogTitle,
} from "./styledComponents";
import { BrandButton } from "components/brand";

import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import useOutsideClick from "hooks/useOutsideClick";

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <StyledDialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </StyledDialogTitle>
  );
}

const ModalWindow = ({
  open,
  setOpen,
  message,
  isQuestion = false,
  setIsConfirmed = () => {},
  submit,
  title,
}) => {
  const modalRef = useRef();

  const handleClose = () => {
    setOpen(false);
    setIsConfirmed(() => false);
  };

  useOutsideClick(modalRef, handleClose);

  return (
    <div>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        ref={modalRef}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
        >
          {title || CONSTANTS.DELETE}
        </BootstrapDialogTitle>
        <BootstrapDialogContent dividers={isQuestion}>
          <Typography gutterBottom>{message}</Typography>
        </BootstrapDialogContent>
        <BootstrapDialogActions>
          <BrandButton variant="secondary" onClick={handleClose}>{CONSTANTS.CANCEL}</BrandButton>
          <BrandButton variant="error" onClick={submit}>{CONSTANTS.CONFIRM}</BrandButton>
        </BootstrapDialogActions>
      </BootstrapDialog>
    </div>
  );
};

export default ModalWindow;
